import { PaymentMethod, paymentMethod, quoteItemStatus, QuoteItemStatusType } from 'noddi-types';

export function shouldPayForOrder({
  status,
  paymentMethodInTireOffer
}: {
  status: QuoteItemStatusType;
  paymentMethodInTireOffer: PaymentMethod;
}) {
  return status === quoteItemStatus.ACCEPTED_WAITING_PAYMENT && paymentMethodInTireOffer === paymentMethod.PAY_BEFORE;
}
